const main = () => {
    const panel = document.querySelector('.l-header__search-panel');
    if (!panel) return;

    const triggers = document.querySelectorAll('[data-open-search-menu]');
    if (!triggers.length) return;

    const close = () => {
        document.body.removeAttribute('data-search-active');
        panel.setAttribute('aria-hidden', 'true');
    };

    const open = () => {
        document.body.setAttribute('data-search-active', '');
        panel.setAttribute('aria-hidden', 'false');
    };

    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (document.body.hasAttribute('data-search-active')) {
                close();
            } else {
                open();
            }
        });
    });

    // オーバーレイ（パネル外）クリックで閉じる
    panel.addEventListener('click', (e) => {
        if (!e.target.closest('.l-header__search-inner')) {
            close();
        }
    });

    // 閉じるボタン
    const closeBtn = panel.querySelector('[data-search-close]');
    if (closeBtn) {
        closeBtn.addEventListener('click', close);
    }

};

export default main;
